"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _Heading = _interopRequireDefault(require("../../text/Heading5"));

var _useToggle3 = _interopRequireDefault(require("../../../hooks/useToggle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var StyledCard = (0, _styledComponents["default"])(_pclnDesignSystem.Card).withConfig({
  componentId: "chxxs2-0"
})(["position:relative;width:100%;color:", ";background-color:", ";border-left:6px solid ", ";border-radius:6px 0 0 6px;"], (0, _pclnDesignSystem.getPaletteColor)('base'), (0, _pclnDesignSystem.getPaletteColor)('background.lightest'), (0, _pclnDesignSystem.getPaletteColor)('base'));
var ExitButton = (0, _styledComponents["default"])(_pclnDesignSystem.Icon).withConfig({
  componentId: "chxxs2-1"
})(["position:absolute;top:8px;right:8px;cursor:pointer;color:", ";"], (0, _pclnDesignSystem.getPaletteColor)('text.base'));
ExitButton.displayName = 'ExitButton';

function Notification(_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen,
      title = _ref.title,
      color = _ref.color,
      iconName = _ref.iconName,
      shadowSize = _ref.shadowSize,
      onClose = _ref.onClose,
      children = _ref.children;

  var _useToggle = (0, _useToggle3["default"])(isOpen),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      open = _useToggle2[0],
      handleClose = _useToggle2[1];

  var onNotificationClose = function onNotificationClose() {
    onClose();
    handleClose();
  };

  return open && _react["default"].createElement(StyledCard, {
    className: className,
    color: color,
    boxShadowSize: shadowSize,
    p: 3
  }, _react["default"].createElement(_pclnDesignSystem.Flex, null, iconName && _react["default"].createElement(_pclnDesignSystem.Icon, {
    name: iconName,
    mr: 2
  }), _react["default"].createElement(_pclnDesignSystem.Flex, {
    flexDirection: "column",
    ml: 2,
    mt: "2px"
  }, _react["default"].createElement(_Heading["default"], null, title), children && _react["default"].createElement(_pclnDesignSystem.Box, {
    id: "notification_children",
    mt: 2
  }, children))), onClose && _react["default"].createElement(ExitButton, {
    name: "close",
    onClick: onNotificationClose
  }));
}

Notification.displayName = 'Notification';
Notification.propTypes = {
  className: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool.isRequired,
  title: _propTypes["default"].string.isRequired,
  color: _propTypes["default"].string,
  iconName: _propTypes["default"].string,
  shadowSize: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  children: _propTypes["default"].node
};
Notification.defaultProps = {
  className: '',
  isOpen: false,
  color: 'primary',
  shadowSize: 'lg'
};

var _default = (0, _react.memo)(Notification);

exports["default"] = _default;